// removed by extract-text-webpack-plugin
module.exports = {"book":"BookCard__book__AlYCi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BookCard/BookCard.css
// module id = 477
// module chunks = 3